"use client";

import { usePathname, useRouter } from "next/navigation";
import { useTranslation } from "react-i18next";
import { cn } from "@/utils/utils";

const IDENTITIES = [
  { key: "express", route: "/express", i18n: "nav.express" },
  { key: "listen", route: "/listen", i18n: "nav.listen" },
  { key: "ask", route: "/ask", i18n: "nav.ask" },
  { key: "solitude", route: "/solitude", i18n: "nav.solitude" },
] as const;

export function IdentityNav() {
  const pathname = usePathname();
  const router = useRouter();
  const { t } = useTranslation();

  return (
    <nav
      aria-label={t("nav.aria")}
      data-el="identity-nav"
      className="fixed left-1/2 z-40 flex w-[min(390px,calc(100vw-24px))] -translate-x-1/2 gap-1.5 rounded-[24px] border border-white/20 bg-[rgba(13,21,35,0.48)] p-2 backdrop-blur-md"
      style={{
        bottom: "calc(var(--eazo-safe-area-bottom) - 6px)",
        boxShadow: "0 10px 35px rgba(0,0,0,0.22)",
      }}
    >
      {IDENTITIES.map((it) => {
        const active = pathname === it.route;
        return (
          <button
            key={it.key}
            data-el={`nav-${it.key}`}
            onClick={() => router.push(it.route)}
            className={cn(
              "flex-1 rounded-[18px] py-2 text-[12px] transition-transform active:scale-95",
              active
                ? "bg-primary text-primary-foreground"
                : "text-[rgba(247,238,217,0.72)]",
            )}
          >
            {t(it.i18n)}
          </button>
        );
      })}
    </nav>
  );
}
